import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, CloudRainIcon, FolderSearchIcon, HeartPulseIcon, PencilRulerIcon, TimerIcon, TrophyIcon, UserMinusIcon, UsersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// WF GOTOWY™ copy (Polish). data/content.ts (legacy) is kept untouched and is not imported.
// TODO: WF GOTOWY mockup – replace PRODUCT_IMAGE with the WF GOTOWY™ box mockup (WebP, transparent).
export const PRODUCT_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/1b2ecac8-2aca-46db-a73d-351022e4ff30/1792344220020_engelska-klar-mockup-caja-6-volymer-44f731e2.webp';
export const heroGuarantees = ['Natychmiastowy dostęp do pobrania', 'Jednorazowa płatność', 'Bez subskrypcji', '7 dni gwarancji satysfakcji'];
export const stats = [{
  value: '6',
  label: 'Cyfrowych tomów do WF'
}, {
  value: '12',
  label: 'Lekcji zaplanowanych minuta po minucie'
}, {
  value: '8',
  label: 'Klas – od 1 do 8'
}, {
  value: '5',
  label: 'Bonusów w zestawie'
}, {
  value: '100',
  label: 'Gotowych komentarzy do oceniania'
}];
export const differenceStats = [{
  value: 'Klasy 1–8',
  label: 'Jeden system dla całej szkoły podstawowej'
}, {
  value: '6 cyfrowych tomów',
  label: 'Od planowania i gier po ocenianie'
}, {
  value: 'PDF-y do wydruku',
  label: 'Do korzystania na ekranie lub w wersji papierowej'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Niedziele znikają na planowaniu',
  text: 'Godziny przed komputerem, żeby zaplanować lekcje WF na kolejny tydzień – a i tak nie wszystko jest gotowe.'
}, {
  title: 'Godziny szukania gier i ćwiczeń',
  text: 'Pomysły z różnych stron internetowych są za łatwe, za trudne albo trzeba je przerabiać, zanim nadadzą się na lekcję.'
}, {
  title: 'Różne poziomy sprawności w jednej klasie',
  text: 'Jedni uczniowie się nudzą, inni nie nadążają – trudno przygotować ćwiczenia, które sprawdzą się u wszystkich.'
}, {
  title: 'Brak motywacji i zwolnienia',
  text: 'Część klasy stoi z boku, a Ty szukasz sposobu, żeby zaangażować w lekcję każdego ucznia.'
}, {
  title: 'Deszcz za oknem i mała sala',
  text: 'Gdy plan na boisko nie wypala, trzeba w ostatniej chwili wymyślić lekcję na niewielkiej przestrzeni.'
}, {
  title: 'Ocenianie i komentarze zajmują czas',
  text: 'Testy sprawności, obserwacje i opisowe komentarze dla każdego ucznia to kolejna praca po lekcjach.'
}];
export const afterItems = ['Uporządkowany system WF dla całej szkoły podstawowej', 'Roczny plan pracy i lekcje zaplanowane minuta po minucie', 'Gry i zabawy ruchowe na każdą okazję – także bez sprzętu', 'Gry zespołowe krok po kroku: przepisy, ćwiczenia i mini-gry', 'Obwody stacyjne, lekkoatletyka i gimnastyka', 'Zadania w trzech poziomach: Wsparcie, Podstawa, Wyzwanie', 'Zdrowy styl życia i bezpieczeństwo w praktyce', 'Testy sprawności, rubryki i gotowe komentarze', 'Materiały gotowe do wydruku'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Niedziele spędzasz na planowaniu',
  text: 'Czy poświęcasz część weekendu na przygotowanie lekcji WF na kolejny tydzień?'
}, {
  icon: FolderSearchIcon,
  title: 'Szukasz gier na dziesięciu stronach',
  text: 'Czy ciągle szukasz gier, zabaw i ćwiczeń dopasowanych do wieku i możliwości uczniów?'
}, {
  icon: UsersIcon,
  title: 'W klasie są bardzo różne poziomy',
  text: 'Czy trudno Ci prowadzić jedną lekcję dla uczniów o zupełnie różnej sprawności?'
}, {
  icon: UserMinusIcon,
  title: 'Uczniowie nie mają motywacji',
  text: 'Czy coraz więcej osób przynosi zwolnienia albo nie chce aktywnie uczestniczyć w zajęciach?'
}, {
  icon: CloudRainIcon,
  title: 'Pada deszcz, a sala jest mała',
  text: 'Czy potrzebujesz gotowych pomysłów na lekcję, gdy nie można wyjść na boisko?'
}, {
  icon: PencilRulerIcon,
  title: 'Ocenianie i zastępstwa to dodatkowa praca',
  text: 'Czy chcesz mieć pod ręką testy, komentarze i gotowe lekcje na zastępstwo?'
}];

// Spine colours mirror the box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Tom 01',
  level: 'Planowanie',
  title: 'Roczny plan pracy + 12 lekcji WF minuta po minucie',
  tagline: 'Wiesz dokładnie, co robić – przez cały rok szkolny.',
  intro: 'Pierwszy tom zawiera roczny plan pracy z wychowania fizycznego oraz dwanaście gotowych lekcji zaplanowanych minuta po minucie.',
  items: ['Roczny plan pracy dla klas 1–8', '12 gotowych lekcji WF', 'Przebieg lekcji minuta po minucie', 'Rozgrzewka, część główna i zakończenie', 'Cele lekcji', 'Szablony do planowania'],
  outro: 'Otwierasz, wybierasz lekcję i wchodzisz na salę z jasnym planem.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 02',
  level: 'Gry i zabawy',
  title: 'Gry i zabawy ruchowe',
  tagline: 'Ruch, śmiech i zaangażowanie całej klasy.',
  intro: 'Drugi tom to zbiór gier i zabaw ruchowych, które łatwo wpleść w każdą lekcję – na sali, na boisku i w małej przestrzeni.',
  items: ['Zabawy bieżne', 'Berki', 'Zabawy z muzyką', 'Gry integracyjne', 'Zabawy bez sprzętu', 'Karty gier do wydruku'],
  outro: 'Gotowe pomysły, które wciągają do ruchu także mniej aktywnych uczniów.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 03',
  level: 'Gry zespołowe',
  title: 'Gry zespołowe: piłka nożna, siatkówka, koszykówka, piłka ręczna',
  tagline: 'Uczysz gier zespołowych krok po kroku.',
  intro: 'Trzeci tom prowadzi uczniów od podstaw do rozegrania meczu w czterech najpopularniejszych grach zespołowych.',
  items: ['Przepisy w prostej formie', 'Ćwiczenia krok po kroku', 'Mini-gry', 'Schematy boisk', 'Sędziowanie', 'Zasady fair play'],
  outro: 'Uporządkowany materiał, dzięki któremu każda lekcja gier ma sens i cel.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 04',
  level: 'Sprawność',
  title: 'Sprawność fizyczna, lekkoatletyka i gimnastyka',
  tagline: 'Rozwijasz sprawność uczniów na każdym poziomie.',
  intro: 'Czwarty tom zawiera ćwiczenia z lekkoatletyki i gimnastyki oraz obwody stacyjne, z zadaniami w trzech poziomach: Wsparcie, Podstawa i Wyzwanie.',
  items: ['Bieg, skok, rzut', 'Obwody stacyjne', 'Ćwiczenia koordynacyjne', 'Elementy gimnastyki', 'Zasady bezpieczeństwa', 'Trzy poziomy trudności'],
  outro: 'Praktyczne wsparcie w pracy z klasą o różnym poziomie sprawności.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 05',
  level: 'Zdrowie',
  title: 'Zdrowy styl życia i bezpieczeństwo',
  tagline: 'WF to także dbanie o zdrowie na co dzień.',
  intro: 'Piąty tom zawiera materiały o zdrowym stylu życia, bezpieczeństwie i podstawach pierwszej pomocy – wraz z projektami i plakatami.',
  items: ['Odżywianie i nawodnienie', 'Sen i regeneracja', 'Prawidłowa postawa', 'Podstawy pierwszej pomocy', 'Projekty dla uczniów', 'Plakaty'],
  outro: 'Treści, które przydadzą się także w deszczowy dzień w sali.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 06',
  level: 'Ocenianie',
  title: 'Ocenianie na WF',
  tagline: 'Oceniasz szybciej, jaśniej i sprawiedliwiej.',
  intro: 'Szósty tom zawiera testy sprawności w dwóch wersjach, karty obserwacji, rubryki w czterech poziomach i 100 gotowych komentarzy.',
  items: ['Testy sprawności A i B', 'Karty obserwacji', 'Rubryki w 4 poziomach', 'Karty samooceny', '100 gotowych komentarzy'],
  outro: 'Praktyczne wsparcie w ocenianiu i informacji zwrotnej dla uczniów.',
  note: 'Testy zostały opracowane niezależnie i nie są oficjalnymi narzędziami Ministerstwa Edukacji Narodowej.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 cyfrowych tomów dla klas 1–8',
  text: 'System sześć w jednym do wychowania fizycznego, który pomaga planować i prowadzić lekcje przez cały rok szkolny.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Gotowe lekcje',
  text: 'Nie zaczynasz od pustej kartki. Dwanaście lekcji zaplanowanych minuta po minucie pozwala szybko ruszyć z pracą.'
}, {
  icon: TimerIcon,
  title: 'Gry i zabawy, które działają',
  text: 'Zabawy bieżne, berki, zabawy z muzyką i gry bez sprzętu, które angażują całą klasę.'
}, {
  icon: TrophyIcon,
  title: 'Gry zespołowe krok po kroku',
  text: 'Piłka nożna, siatkówka, koszykówka i piłka ręczna: przepisy, ćwiczenia, mini-gry i schematy boisk.'
}, {
  icon: HeartPulseIcon,
  title: 'Zdrowie i bezpieczeństwo',
  text: 'Odżywianie, nawodnienie, sen, postawa i podstawy pierwszej pomocy – z projektami i plakatami.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Wsparcie w ocenianiu',
  text: 'Testy sprawności A/B, karty obserwacji, rubryki w 4 poziomach i 100 gotowych komentarzy.'
}, {
  icon: CalendarCheckIcon,
  title: 'Roczny plan pracy',
  text: 'Wsparcie w zorganizowaniu lekcji wychowania fizycznego na cały rok szkolny.'
}];

// TODO: WF GOTOWY Tom 1 sample pages. The "Zajrzyj do środka" section stays hidden while the list in data/samples.ts is empty.
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [];
export const pageTypes = ['Gotowe lekcje', 'Gry i zabawy', 'Ćwiczenia i obwody stacyjne', 'Materiały do oceniania'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Rozgrzewki w 5 minut',
  text: 'Gotowe rozgrzewki, od których możesz zacząć każdą lekcję WF.',
  items: ['Gotowe rozgrzewki', 'Szybki start lekcji', 'Do użycia od razu'],
  benefit: 'Sprawny początek każdej lekcji.'
}, {
  title: 'Szkolny Dzień Sportu',
  text: 'Gotowy scenariusz i materiały, które pomagają zorganizować dzień sportu w szkole.',
  items: ['Gotowy scenariusz', 'Materiały organizacyjne', 'Do wydruku'],
  benefit: 'Mniej stresu przy organizacji szkolnego wydarzenia.'
}, {
  title: 'Komunikacja z rodzicami',
  text: 'Gotowe wiadomości i formularze dla rodziców – np. w sprawie stroju sportowego czy zwolnień.',
  items: ['Gotowe wiadomości', 'Formularze dla rodziców'],
  benefit: 'Mniej czasu na pisanie do rodziców.'
}, {
  title: 'Zastępstwa na WF bez stresu',
  text: 'Gotowe lekcje dla nauczyciela, który prowadzi zajęcia na zastępstwie.',
  items: ['Gotowe lekcje na zastępstwo', 'Łatwe do przekazania', 'Do wydruku'],
  benefit: 'Spokój, gdy nie możesz być na lekcji osobiście.'
}, {
  title: 'Plakaty na salę gimnastyczną',
  text: 'Plakaty o tematyce sportowej i zdrowotnej do powieszenia na sali.',
  items: ['Plakaty do wydruku', 'Wizualne wsparcie na sali'],
  benefit: 'Sala, która codziennie motywuje do ruchu.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Otwórz WF GOTOWY™',
  text: 'Pobierz pakiet i otwórz potrzebny tom.'
}, {
  title: 'Wybierz lekcję i materiały',
  text: 'Wybierz lekcję, grę, ćwiczenia lub test dopasowany do Twojej klasy.'
}, {
  title: 'Wydrukuj',
  text: 'Wydrukuj to, czego potrzebujesz, albo korzystaj z materiałów na ekranie.'
}, {
  title: 'Prowadź lekcję',
  text: 'Wejdź na salę z jasnym planem.'
}];
export const audienceItems = ['Uczysz WF w klasach 1–3, 4–6 lub 7–8', 'Chcesz mieć uporządkowany WF na cały rok szkolny', 'Nie chcesz co tydzień planować lekcji od zera', 'Chcesz zaangażować także mniej aktywnych uczniów', 'Szukasz gier i zabaw na salę, boisko i małą przestrzeń', 'Chcesz mieć pod ręką testy, rubryki i komentarze', 'Chcesz zaoszczędzić czas na planowaniu', 'Chcesz wchodzić na każdą lekcję z gotowym planem'];
export const timeValueTasks = ['Szukanie gier i ćwiczeń na różnych stronach', 'Planowanie lekcji', 'Wymyślanie zabaw na deszczowe dni', 'Przygotowywanie lekcji na zastępstwa', 'Testy sprawności i komentarze do ocen'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 cyfrowych tomów',
  detail: 'Planowanie, gry i zabawy, gry zespołowe, sprawność, zdrowie i ocenianie'
}, {
  label: '5 bonusów bez dodatkowych kosztów',
  detail: 'Rozgrzewki, dzień sportu, komunikacja z rodzicami, zastępstwa i plakaty'
}, {
  label: 'Dla klas 1–8',
  detail: 'Gotowe lekcje, gry, ćwiczenia i materiały do oceniania'
}];
export const offerIncludes = ['Natychmiastowy dostęp do pobrania', 'Pliki PDF do zapisania', 'Materiały do wydruku', 'Nie wysyłamy produktu fizycznego'];
export const PRICE = '99 zł';
export const OLD_PRICE = '199 zł';

// Only add authentic reviews of WF GOTOWY™. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Jak otrzymam materiały?',
  a: 'WF GOTOWY™ jest produktem cyfrowym. Po zakupie otrzymujesz dostęp do plików PDF, które możesz pobrać i zapisać. Możesz korzystać z nich na komputerze, tablecie lub telefonie i drukować to, czego potrzebujesz.'
}, {
  q: 'Czy WF GOTOWY™ jest przygotowany z myślą o polskiej szkole?',
  a: 'Tak. Materiały zostały przygotowane dla nauczycieli wychowania fizycznego w polskich szkołach podstawowych, w klasach 1–8. To niezależny materiał dydaktyczny, a nie oficjalny produkt Ministerstwa Edukacji Narodowej (MEN).'
}, {
  q: 'Czy pakiet sprawdzi się w klasach 1–8?',
  a: 'Tak. Wybierasz materiały odpowiednie do klasy i zagadnienia, które realizujesz.'
}, {
  q: 'Czy naprawdę mogę przygotować lekcję w 5 minut?',
  a: 'WF GOTOWY™ został stworzony po to, by przyspieszyć przygotowanie lekcji. Możesz otworzyć tom, wybrać gotową lekcję lub grę i zapoznać się z nią w około pięć minut. Czas może się różnić w zależności od treści lekcji, klasy i potrzebnych dostosowań.'
}, {
  q: 'Czy materiałów wystarczy na cały rok szkolny?',
  a: 'WF GOTOWY™ zawiera roczny plan pracy i materiały, z których możesz korzystać przez cały rok szkolny. To Ty wybierasz, łączysz i dostosowujesz je do swojego planu i potrzeb uczniów.'
}, {
  q: 'Czy są gotowe gry i ćwiczenia?',
  a: 'Tak. Pakiet zawiera gry i zabawy ruchowe, ćwiczenia do gier zespołowych, obwody stacyjne oraz ćwiczenia z lekkoatletyki i gimnastyki – wraz z kartami do wydruku.'
}, {
  q: 'Czy pakiet pomaga w ocenianiu?',
  a: 'Tak. Pakiet zawiera testy sprawności A/B, karty obserwacji, rubryki w 4 poziomach, karty samooceny i 100 gotowych komentarzy.'
}, {
  q: 'Czy mogę korzystać z materiałów w klasie o różnym poziomie sprawności?',
  a: 'Tak. Zadania są przygotowane w trzech poziomach – Wsparcie, Podstawa i Wyzwanie – a Ty wybierasz i dostosowujesz je do możliwości i potrzeb uczniów.'
}, {
  q: 'Czy muszę wszystko drukować?',
  a: 'Nie. To Ty decydujesz, które strony wydrukować, a z części materiałów możesz korzystać na ekranie.'
}, {
  q: 'Czy pięć bonusów jest w cenie?',
  a: `Tak. Wszystkich pięć bonusów jest w pakiecie bez dodatkowych kosztów – całość za ${PRICE}.`
}, {
  q: 'Czy to subskrypcja?',
  a: 'Nie. Płacisz jednorazowo i otrzymujesz dostęp do materiałów cyfrowych. Bez żadnych opłat cyklicznych.'
}, {
  q: 'Czy mogę zapisać pliki?',
  a: 'Tak. Możesz pobrać i zapisać pliki PDF, aby korzystać z nich dalej zgodnie z warunkami korzystania z produktu.'
}, {
  q: 'Czy mogę korzystać z materiałów na telefonie lub tablecie?',
  a: 'Tak. Pliki PDF otworzysz na komputerze, tablecie i telefonie. Aby sprawdzić układ stron przed wydrukiem, polecamy komputer lub tablet.'
}, {
  q: 'Czy jest gwarancja?',
  a: 'Tak. WF GOTOWY™ objęty jest 7-dniową gwarancją satysfakcji. Jeśli materiały nie spełnią Twoich oczekiwań, możesz skontaktować się z nami i poprosić o zwrot pieniędzy w okresie gwarancji, zgodnie z jej warunkami.'
}];
export const footerLinks = ['Regulamin', 'Polityka prywatności', 'Polityka zwrotów', 'Kontakt'];
